import Header from '../../components/admin/header/Header';

import Write from '../../components/admin/review/Write';

export default function NoticeWrite() {
  return (
    <>
      <Header></Header>
        <Write />
    </>
  );
}
